var exports = {
  "kL": "ChannelWebhooksTab.module__container___WWtSV0",
  "wx": "ChannelWebhooksTab.module__header___WWtSV0",
  "h_": "ChannelWebhooksTab.module__description___WWtSV0",
  "UD": "ChannelWebhooksTab.module__buttonContainer___WWtSV0",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___WWtSV0",
  "Xb": "ChannelWebhooksTab.module__messageBox___WWtSV0",
  "PQ": "ChannelWebhooksTab.module__webhooksList___WWtSV0",
  "wp": "ChannelWebhooksTab.module__followedSection___WWtSV0",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___WWtSV0",
  "yV": "ChannelWebhooksTab.module__sectionDescription___WWtSV0",
};

module.exports = exports;
